import axios from 'axios';

const instance = axios.create();
instance.defaults.baseURL = process.env.VUE_APP_REVERSE_PROXY_ENDPOINT || "http://localhost:8080";
instance.defaults.timeout = 50000;
instance.defaults.withCredentials = true;

// Flag to avoid multiple token refresh requests
let isRefreshing = false;
let subscribers = [];

// Function to subscribe callbacks that will retry requests
function subscribeTokenRefresh(callback) {
  subscribers.push(callback);
}

// Notify all subscribed requests to retry after refresh
function onTokenRefreshed() {
  subscribers.forEach((callback) => callback());
  subscribers = [];
}

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Exclude the 'renew-access-token' endpoint from being intercepted
    if (originalRequest.url === 'api/auth/renew-access-token') {
      return Promise.reject(error);
    }

    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      if (!isRefreshing) {
        isRefreshing = true;

        return new Promise((resolve, reject) => {
          subscribeTokenRefresh(() => {
            resolve(instance(originalRequest));
          });
          instance.get('api/auth/renew-access-token')
            .then(() => {
              onTokenRefreshed();
              isRefreshing = false;
            })
            .catch((refreshError) => {
              isRefreshing = false;
              subscribers.forEach((callback) => callback(Promise.reject(refreshError)));
              subscribers = [];
              this.$store.commit("setAuthUser", null);
              this.$store.commit("setCurrentEmail", null);
              this.$store.commit("setUserLevel", null);
              reject(refreshError);
            });
        });
      }

      return new Promise((resolve) => {
        subscribeTokenRefresh(() => {
          resolve(instance(originalRequest));
        });
      });
    }

    return Promise.reject(error); // Reject other errors
  }
);

export default instance;